import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import ReportsService from './reportsService';

export const fetchRecruitmentOverviewReportCities = createAsyncThunk(
  'reports/fetchRecruitmentOverviewReportCities',
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await ReportsService.getRecruitmentOverviewReportCities();

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchRecruitmentOverviewReportStatistics = createAsyncThunk(
  'reports/fetchRecruitmentOverviewReportStatistics',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const { days, locations } = state.filters;

    try {
      const response =
        await ReportsService.getRecruitmentOverviewReportStatistics({
          days,
          locations
        });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchRecruitmentOverviewReportJobs = createAsyncThunk(
  'reports/fetchRecruitmentOverviewReportJobs',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const { page, pageSize, sortField, order, days, locations } = state.filters;

    try {
      const response = await ReportsService.getRecruitmentOverviewReportJobs({
        page,
        pageSize,
        sortField,
        order,
        days,
        locations
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchRecruitmentOverviewReportClosedHires = createAsyncThunk(
  'reports/fetchRecruitmentOverviewReportClosedHires',
  async (jobId: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      const { days } = state.filters;

      const response =
        await ReportsService.getRecruitmentOverviewReportClosedHires({
          days,
          jobId
        });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
